export const SET_AUTH = 'SET_AUTH';
export const SET_TRANSACTION_ID = 'SET_TRANSACTION_ID';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_CALL_BACK_PARAM = 'SET_CALL_BACK_PARAM';
export const mutations = {
    [SET_AUTH](state, payload) {
        state.auth = payload;
    },
    [SET_USER_INFO](state, payload) {
        state.userInfo = payload;
    },
    [SET_TRANSACTION_ID](state, payload) {
        state.transactionId = payload;
    },
    [SET_CALL_BACK_PARAM](state, payload) {
        state.callBackParam = payload;
    },
};
